const SubscriptionChecklistType = Object.freeze({
  PRIMARY_CHECKLIST: 1,
  SECONDARY_CHECKLIST: 2,
});

const SubscriptionChecklistItemType = Object.freeze({
  NULLENUM: 0,
  CONNECT_DEVICES: 1,
  DOWNLOAD_MOBILE_APP: 2,
  CREATE_ALERT: 3,
  CREATE_SENSOR_METRIC: 4,
  ADD_USER: 5,
  CONFIGURE_USER_ROLES: 6,
  SCHEDULE_QUIET_TIMES: 7,
  ENABLE_REPEAT_NOTIFICATION: 8,
  CREATE_CUSTOM_ALERT_MESSAGES: 9,
  SHARE_REPORTS: 10,
  CREATE_MONITOR360: 11,
  ENABLE_SAML: 12,
  ENABLE_MFA: 13,
  CONFIRM_BILLING_EMAIL: 14,
  SHARE_FEEDBACK: 15,
});

export { SubscriptionChecklistItemType, SubscriptionChecklistType };
